const initialTimeSeries = {
    lastWeek: [],
    lastMonth: [],
    lastYear: [],
};


export const initialState = {
    counters: [],
    markets: [],
    timeSeries: initialTimeSeries,
    balance: initialTimeSeries,
    recentPredictions: [],
    predictionsByMarketType: [],
    predictionsByMarketOptions: {},
    predictionsByMarketStatus: [],
    triplePredictions: [],
    isLoading: true,
};


export const reducer = (state = initialState, action) => {
    switch (action.type) {
        case 'set_markets':
            return { ...state, markets: action.payload };
        case 'set_balance':
            return { ...state, balance: action.payload };
        case 'set_triple_predictions':
            return { ...state, triplePredictions: action.payload };
        case 'set_prediction_timeseries':
            return { ...state, timeSeries: action.payload };
        case 'set_predictions_overview':
            return { ...state, counters: action?.payload?.counters, recentPredictions: action?.payload?.recent };
        case 'set_predictions_by_market':
            return { ...state, predictionsByMarketStatus: action?.payload?.byMarketStatus, predictionsByMarketType: action?.payload?.pieByMarket };
        case 'set_predictions_by_market_options':
            return { ...state, predictionsByMarketOptions: action.payload };
        case 'set_loading':
            return { ...state, isLoading: action.payload };
        default:
            return state;
    }
};